import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UserService } from "../../../../../shared";
import { StringRequest } from "../../../school-type-setup/shared/StringRequest";
import { DataService_FacilitySetup } from "../data.service";

@Component({
	selector: "caass-siteadmin-facility-name",
	templateUrl: "./siteadmin-facility-name.component.html",
	styleUrls: ["./siteadmin-facility-name.component.css"],
})
export class SiteadminFacilityNameComponent implements OnInit {
	constructor(private userService: UserService, private facilityService: DataService_FacilitySetup) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//Update From main (for edit mode or if the user goes backwards)
		this.UpdateFromMain();
	}

	ngOnChanges() {
		this.UpdateFromMain();
	}

	UpdateFromMain() {
		// this.DataLoading = true;

		//Update From main (for edit mode or if the user goes backwards)
		if (this.FacilityNameFromMain != undefined) {
			this.FacilityName = this.FacilityNameFromMain;
		}
		if (this.FacilityCodeFromMain != undefined) {
			this.FacilityCode = this.FacilityCodeFromMain;
		}
		if (this.PhoneFromMain != undefined) {
			this.Phone = this.PhoneFromMain;
		}
		if (this.AddressFromMain != undefined) {
			this.Address = this.AddressFromMain;
		}
		if (this.CityFromMain != undefined) {
			this.City = this.CityFromMain;
		}
		if (this.StateFromMain != undefined) {
			this.State = this.StateFromMain;
		}
		if (this.ZipFromMain != undefined) {
			this.Zip = this.ZipFromMain;
		}

		// this.DataLoading = false;
	}

	//////////////////////////////////////
	// Data
	//////////////////////////////////////
	@Input() DataLoading: any = true;

	@Output() NextClick: EventEmitter<any> = new EventEmitter();

	user: any;

	@Input() EditMode: any = false;
	@Input() FacilityNameFromMain: any;
	@Input() FacilityCodeFromMain: any;
	@Input() PhoneFromMain: any;
	@Input() AddressFromMain: any;
	@Input() CityFromMain: any;
	@Input() StateFromMain: any;
	@Input() ZipFromMain: any;

	//Form Data
	FacilityName: any = "";
	FacilityCode: any = "";
	UserLevelDesc: any = ""; //
	Phone: any = "";
	Address: any = "";
	City: any = "";
	State: any = "";
	Zip: any = "";

	//Edit Mode
	OriginalFacilityName: any = "";
	OriginalFacilityCode: any = "";

	errorMessage: any = "";

	//////////////////////////////////////

	//////////////////////////////////////
	// Buttons
	//////////////////////////////////////

	onNext() {
		/////////////////////////////////////////////////
		// Testing                                     //
		/////////////////////////////////////////////////
		// this.FinishNext();
		/////////////////////////////////////////////////

		this.errorMessage = "";

		//Error Handling:

		//Check for null values:
		//if(this.FacilityName == ""){
		//  this.errorMessage = "Enter a Facility Name";
		//  return;
		//}
		//if(this.FacilityCode == ""){
		//  this.errorMessage = "Enter a Facility Code";
		//  return;
		//}
		//if(this.Phone == ""){
		//  this.errorMessage = "Enter a Phone Number";
		//  return;
		//}
		//if(this.Address == ""){
		//  this.errorMessage = "Enter a Street Address";
		//  return;
		//}
		//if(this.City == ""){
		//  this.errorMessage = "Enter a City";
		//  return;
		//}
		//if(this.State == ""){
		//  this.errorMessage = "Enter a State";
		//  return;
		//}
		//if(this.Zip == ""){
		//  this.errorMessage = "Enter a Zip Code";
		//  return;
		//}

		////Check format
		//if(!this.ValidPhone()){
		//  this.errorMessage = "Enter a valid phone number using the format (###)-###-####";
		//  return;
		//}

		if (this.EditMode == false) {
			this.CheckName();
		}
		//Edit mode error handling
		else {
			if (this.FacilityName != this.FacilityNameFromMain) {
				this.CheckName();
			} else if (this.FacilityCode != this.FacilityCodeFromMain) {
				this.CheckCode();
			} else {
				this.FinishNext();
			}
		}
		// this.FinishNext(); //Testing
	}

	CheckName() {
		let parms: StringRequest = {
			str: this.FacilityName,
		};

		var result = this.facilityService.FacilityNameInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Facility Name Already in Use";
					return;
				} else {
					if (this.EditMode == false) {
						this.CheckCode();
					} else {
						if (this.FacilityCode != this.FacilityCodeFromMain) {
							this.CheckCode();
						} else {
							this.FinishNext();
						}
					}
				}
			},
			(error) => {}
		);
	}

	CheckCode() {
		let parms: StringRequest = {
			str: this.FacilityCode,
		};

		var result = this.facilityService.FacilityCDInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Facility Code Already in Use";
					return;
				} else {
					this.FinishNext();
				}
			},
			(error) => {}
		);
	}

	FinishNext() {
		let myData: any = {
			FacilityName: this.FacilityName,
			FacilityCode: this.FacilityCode,
			Phone: this.Phone,
			Address: this.Address,
			City: this.City,
			State: this.State,
			Zip: this.Zip,
		};

		this.NextClick.emit({
			NextPage: 1,
			Data: myData,
		});
	}

	//////////////////////////////////////

	//////////////////////////////////////
	// Helpers
	//////////////////////////////////////
	GetUserLevelDesc() {
		if (this.user != undefined) {
			if (this.user.UserLevelID == 1) {
				return "District User";
			} else if (this.user.UserLevelID == 3) {
				return "School User";
			} else {
				return "User";
			}
		} else {
			return "User";
		}
	}

	ValidPhone() {
		var temp = this.Phone;

		//Reformat
		temp = this.ReplaceAllOccur(temp, "-", "");
		temp = this.ReplaceAllOccur(temp, "(", "");
		temp = this.ReplaceAllOccur(temp, ")", "");

		//Check Length
		if (temp.length != 10) {
			return false;
		}

		//Check for non-number
		if (this.ContainsLetters(temp)) {
			return false;
		}

		return true;
	}

	ReplaceAllOccur(Mainstr: string, findStr: string, replaceStr: string) {
		let ans = String(Mainstr);
		while (ans.indexOf(findStr) != -1) {
			ans = ans.replace(findStr, replaceStr);
		}

		return ans;
	}

	ContainsLetters(str) {
		if (str == undefined) {
			return true; //Throw error
		}

		for (var i = 0; i < str.length; i++) {
			var nextChar = String(str).substring(i, i + 1);

			if (isNaN(Number(nextChar))) {
				return true;
			}
		}

		return false;
	}

	//////////////////////////////////////
}
